export function checkPortalManagerPermissions(permissions: string[]) {
  const minimumRequiredPermissions = ['boards:read', 'assets:read', 'me:read', 'workspaces:read', 'account:read'];

  const additionalFeaturePermissions = {
    'item-comments': ['updates:read', 'updates:write'],
    'item-edit': ['boards:write'],
  };

  const hasMinimumPermissions = minimumRequiredPermissions.every((permission) => permissions.includes(permission));
  const hasAdditionalFeaturePermissions = Object.values(additionalFeaturePermissions).every((permissionsArray) =>
    permissionsArray.every((permission) => permissions.includes(permission)),
  );

  const hasAllPermissions = hasMinimumPermissions && hasAdditionalFeaturePermissions;

  function canUseFeature(feature: keyof typeof additionalFeaturePermissions) {
    const requiredPermissions = additionalFeaturePermissions[feature] || [];
    return requiredPermissions.every((permission) => permissions.includes(permission));
  }

  function featuresWithMissingPermissions() {
    const missingPermissions = Object.entries(additionalFeaturePermissions)
      .filter(([feature]) => !canUseFeature(feature as keyof typeof additionalFeaturePermissions))
      .map(([feature]) => feature);

    return missingPermissions;
  }

  return {
    hasMinimumPermissions,
    hasAllPermissions,
    canUseFeature,
    featuresWithMissingPermissions,
  };
}
